import { DSFlex } from '@/components/ds/Flex/Flex'
import Image from 'next/image'
import React from 'react'
import { DSShow } from '@/components/ds/Responsive/Show/Show'
import { Logo } from '@/components/shared/Logo'
import styled from 'styled-components'
import { QuizCTA } from '@/components/pages/quiz/QuizCTA'
import { DSSpacer } from '@/components/ds/Spacer/Spacer'
import { BREAKPOINTS } from '@/components/ds/breakpoints'

const MainContainer = styled.div`
  padding: 0 var(--grid-24);
  height: 100vh;

  @media screen and (max-width: ${BREAKPOINTS.l}) {
    padding: var(--grid-24);
    height: unset;
  }
`
const StyledRightContainer = styled.div`
  max-width: 520px;
  padding-left: 72px;

  @media screen and (max-width: ${BREAKPOINTS.m}) {
    padding-left: unset;
    height: 100%;
    width: unset;
  }
`

interface QuizLandingPageVariantBProps {
  checkoutCountry?: string
}

export const QuizLandingPageContent = ({ checkoutCountry }: QuizLandingPageVariantBProps) => {
  return (
    <MainContainer>
      <DSShow below="m">
        <Logo colour="brand" size="mobile" />
      </DSShow>
      <DSFlex
        justifyContent="space-between"
        alignItems="center"
        breakConfig={{
          maxViewportDirection: 'row',
          breakAt: {
            breakPoint: 'm',
            direction: 'column',
          },
        }}
      >
        <DSFlex direction="row" flex="1" justifyContent="center">
          <Image width={420} height={400} src="/assets/img/quiz/onboarding.jpg" alt="zoe-onboarding-flag" />
        </DSFlex>
        <DSShow below="l">
          <DSSpacer size={32} direction="vertical" />
        </DSShow>
        <DSFlex direction="column" flex="1" justifyContent="center" height="100vh">
          <StyledRightContainer>
            <DSShow above="m">
              <Logo colour="brand" size="desktop" />
              <DSSpacer size={32} direction="vertical" />
            </DSShow>
            <QuizCTA checkoutCountry={checkoutCountry} />
          </StyledRightContainer>
        </DSFlex>
      </DSFlex>
    </MainContainer>
  )
}
